module.exports = "/_next/static/images/letter-duotone-d3b39046ffed660cfbf096e768d3b92c.svg";